export const FreeConstants = {
  outputFields: 4,
  customFields: 1,
  parameters: 1,
}
